import React from 'react';
import './blogs.scss';
import SEO from '../components/shared/seo';
import Pagination from '../components/shared/navigation/pagination/pagination';
import Card from '../components/shared/ui-elements/card/card';

var BlogsPage = function BlogsPage(_ref) {
  var data = _ref.data,
      pageContext = _ref.pageContext;
  var language = pageContext.language;
  var blogs = data.allSanityBlog.edges; // const { allLikes } = useContext(LikesContext)

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: language === 'en' ? 'Blog' : 'ブログ',
    lang: language
  }), /*#__PURE__*/React.createElement("div", {
    className: "blogs-page"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "blogs-page__list"
  }, blogs.map(function (_ref2, i) {
    var _b$title, _b$title2, _b$slug, _b$thumbnail, _b$thumbnail$asset, _b$category, _b$category$title, _b$category2, _b$category2$title;

    var b = _ref2.node;
    var newBlog = {
      title: language === 'en' ? (_b$title = b.title) === null || _b$title === void 0 ? void 0 : _b$title.en : (_b$title2 = b.title) === null || _b$title2 === void 0 ? void 0 : _b$title2.ja,
      slug: (_b$slug = b.slug) === null || _b$slug === void 0 ? void 0 : _b$slug.current,
      date: language === 'en' ? new Date(b.publishedAt).toLocaleDateString('en-US') : new Date(b.publishedAt).toLocaleDateString('ja-JP'),
      thumbnail: (_b$thumbnail = b.thumbnail) === null || _b$thumbnail === void 0 ? void 0 : (_b$thumbnail$asset = _b$thumbnail.asset) === null || _b$thumbnail$asset === void 0 ? void 0 : _b$thumbnail$asset.fluid,
      category: language === 'en' ? (_b$category = b.category) === null || _b$category === void 0 ? void 0 : (_b$category$title = _b$category.title) === null || _b$category$title === void 0 ? void 0 : _b$category$title.en : (_b$category2 = b.category) === null || _b$category2 === void 0 ? void 0 : (_b$category2$title = _b$category2.title) === null || _b$category2$title === void 0 ? void 0 : _b$category2$title.ja,
      likes: b.likes,
      id: b._id
    };
    return /*#__PURE__*/React.createElement(Card, {
      key: i,
      item: newBlog,
      place: "blogs-page"
    });
  })), /*#__PURE__*/React.createElement(Pagination, {
    context: pageContext
  })));
};

export default BlogsPage;
var pageQuery = "4230755739";